import React from 'react';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { AppBar, ThemeProvider, Toolbar, useMediaQuery } from '@mui/material';

import FuseSearch from '@fuse/core/FuseSearch';
import FuseShortcuts from '@fuse/core/FuseShortcuts';
import ChatPanelToggleButton from 'app/fuse-layouts/shared-components/chatPanel/ChatPanelToggleButton';
import NavbarToggleButton from 'app/fuse-layouts/shared-components/NavbarToggleButton';
import UserMenu from 'app/fuse-layouts/shared-components/UserMenu';
import { selectToolbarTheme } from 'app/store/fuse/settingsSlice';
import AdjustFontSize from '../../shared-components/AdjustFontSize';
import FullScreenToggle from '../../shared-components/FullScreenToggle';
import LanguageSwitcher from '../../shared-components/LanguageSwitcher';
import NotificationPanelToggleButton from '../../shared-components/notificationPanel/NotificationPanelToggleButton';

function ToolbarLayout2({ className }: { className?: string }) {
	const isLgUp = useMediaQuery(theme => theme.breakpoints.up('lg'));

	const config = useSelector(({ fuse }: any) => fuse.settings.current.layout.config);
	const toolbarTheme = useSelector(selectToolbarTheme);

	return (
		<ThemeProvider theme={toolbarTheme}>
			<AppBar
				id="fuse-toolbar"
				className={clsx('relative z-20 flex shadow-md', className)}
				color="default"
				style={{ backgroundColor: toolbarTheme.palette.background.paper }}
			>
				<Toolbar className="container min-h-48 p-0 md:min-h-64 lg:px-24">
					{config.navbar.display && !isLgUp && <NavbarToggleButton className="mx-0 h-40 w-40 p-0 sm:mx-8" />}

					<div className="flex flex-1">{isLgUp && <FuseShortcuts />}</div>

					<div className="flex h-full items-center overflow-x-auto px-8">
						<LanguageSwitcher />

						<AdjustFontSize />

						<FullScreenToggle />

						<FuseSearch />

						{!isLgUp && <ChatPanelToggleButton />}

						<NotificationPanelToggleButton />

						<UserMenu />
					</div>
				</Toolbar>
			</AppBar>
		</ThemeProvider>
	);
}

export default React.memo(ToolbarLayout2);
